module.exports = __webpack_public_path__ + "static/media/add descriptive report.5542ca03.svg";